import { FC, memo } from 'react'

import { HandClicking, RobotVacuumCleaner, SmallLaboratoryTube } from 'components/icons'
import { Tooltip, Box } from '@chakra-ui/react'

type Props = {
  origin?: string
  labels?: any
}

const DEFAULTS_LABES: any = {
  MANUAL: 'Criado manualmente',
  SCIENTIST: 'Criado sob demanda',
  CRAWLER: 'Criado automáticamente',
}

const OriginIcon: FC<Props> = ({ origin, labels }) => {
  if (!origin) return <></>

  const label = labels ? labels[origin] : DEFAULTS_LABES[origin]

  if (origin === 'MANUAL') {
    return (
      <Tooltip label={label}>
        <Box>
          <HandClicking color="dark" />
        </Box>
      </Tooltip>
    )
  }

  if (origin === 'SCIENTIST') {
    return (
      <Tooltip label={label}>
        <Box>
          <SmallLaboratoryTube color="dark" />
        </Box>
      </Tooltip>
    )
  }

  if (origin === 'CRAWLER') {
    return (
      <Tooltip label={label}>
        <Box>
          <RobotVacuumCleaner color="dark" />
        </Box>
      </Tooltip>
    )
  }

  return <></>
}

export default memo(OriginIcon)
